import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPausedEnvelope = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="currentColor"><path d="M25.468 14.038c-.326 0-.653.064-.98.064V4.898H0V24.49h20.245a6.518 6.518 0 0 0 5.223 2.612c3.59 0 6.532-2.938 6.532-6.532s-2.941-6.532-6.532-6.532zM1.501 6.53h21.42v3.2l-10.645 7.118L1.501 9.731zm0 16.325V11.622l9.927 6.596h1.632l9.928-6.596v2.874c-2.42 1.046-4.052 3.331-4.052 6.074 0 .784.132 1.568.39 2.285zm23.967 2.941c-2.874 0-5.223-2.352-5.223-5.223 0-2.87 2.352-5.223 5.223-5.223 2.87 0 5.223 2.353 5.223 5.223 0 2.87-2.349 5.223-5.223 5.223z" /><path d="M23.51 17.59h1.305v6.027H23.51zm2.611 0h1.306v6.027H26.12z" /></g></svg>;
export default SvgPausedEnvelope;